import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './Auth.css';

const Login = ({ onSwitchToSignup, onSwitchToForgotPassword }) => {
    const { login, loginWithSSO, setNewPassword, loading, error, clearError } = useAuth();
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });
    const [newPasswordData, setNewPasswordData] = useState({
        newPassword: '',
        confirmPassword: '',
    });
    const [showNewPasswordForm, setShowNewPasswordForm] = useState(false);
    const [cognitoUser, setCognitoUser] = useState(null);
    const [formErrors, setFormErrors] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear field error when user starts typing
        if (formErrors[name]) {
            setFormErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleNewPasswordChange = (e) => {
        const { name, value } = e.target;
        setNewPasswordData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear field error when user starts typing
        if (formErrors[name]) {
            setFormErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const errors = {};
        
        if (!formData.email.trim()) {
            errors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errors.email = 'Email is invalid';
        }
        
        if (!formData.password) {
            errors.password = 'Password is required';
        }
        
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const validateNewPasswordForm = () => {
        const errors = {};
        
        if (!newPasswordData.newPassword) {
            errors.newPassword = 'New password is required';
        } else if (newPasswordData.newPassword.length < 8) {
            errors.newPassword = 'Password must be at least 8 characters';
        }
        
        if (!newPasswordData.confirmPassword) {
            errors.confirmPassword = 'Please confirm your password';
        } else if (newPasswordData.newPassword !== newPasswordData.confirmPassword) {
            errors.confirmPassword = 'Passwords do not match';
        }
        
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        clearError();
        
        if (!validateForm()) {
            return;
        }

        try {
            const result = await login(formData.email, formData.password);
            
            if (result.newPasswordRequired) {
                setShowNewPasswordForm(true);
                setCognitoUser(result.user);
            }
            // If login is successful without new password requirement, 
            // the AuthContext will handle the user state update
        } catch (err) {
            console.error('Login error:', err);
        }
    };

    const handleNewPasswordSubmit = async (e) => {
        e.preventDefault();
        clearError();
        
        if (!validateNewPasswordForm()) {
            return;
        }

        try {
            await setNewPassword(cognitoUser, newPasswordData.newPassword);
            setShowNewPasswordForm(false);
            setCognitoUser(null);
            setNewPasswordData({ newPassword: '', confirmPassword: '' });
        } catch (err) {
            console.error('New password error:', err);
        }
    };

    if (showNewPasswordForm) {
        return (
            <div className="auth-container">
                <div className="auth-form">
                    <h2>Set New Password</h2>
                    <p className="auth-subtitle">Please set a new password for your account</p>
                    
                    {error && <div className="error-message">{error}</div>}
                    
                    <form onSubmit={handleNewPasswordSubmit}>
                        <div className="form-group">
                            <label htmlFor="newPassword">New Password</label>
                            <input
                                type="password"
                                id="newPassword"
                                name="newPassword"
                                value={newPasswordData.newPassword}
                                onChange={handleNewPasswordChange}
                                className={formErrors.newPassword ? 'error' : ''}
                                placeholder="Enter new password"
                            />
                            {formErrors.newPassword && <span className="field-error">{formErrors.newPassword}</span>}
                        </div>

                        <div className="form-group">
                            <label htmlFor="confirmPassword">Confirm Password</label>
                            <input
                                type="password"
                                id="confirmPassword"
                                name="confirmPassword"
                                value={newPasswordData.confirmPassword}
                                onChange={handleNewPasswordChange}
                                className={formErrors.confirmPassword ? 'error' : ''}
                                placeholder="Confirm new password"
                            />
                            {formErrors.confirmPassword && <span className="field-error">{formErrors.confirmPassword}</span>}
                        </div>

                        <button 
                            type="submit" 
                            className="auth-button"
                            disabled={loading}
                        >
                            {loading ? 'Setting Password...' : 'Set Password'}
                        </button>
                    </form>
                </div>
            </div>
        );
    }

    return (
        <div className="auth-container">
            <div className="auth-form">
                <div className="auth-title">
                    <h1 className="mixo-title">MIXO</h1>
                    <div className="title-underline"></div>
                </div>
                <h2>Sign In</h2>
                <p className="auth-subtitle">Welcome back! Please sign in to your account</p>
{/*                 
                {error && <div className="error-message">{error}</div>}
                
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            className={formErrors.email ? 'error' : ''}
                            placeholder="Enter your email"
                        />
                        {formErrors.email && <span className="field-error">{formErrors.email}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleInputChange}
                            className={formErrors.password ? 'error' : ''}
                            placeholder="Enter your password"
                        />
                        {formErrors.password && <span className="field-error">{formErrors.password}</span>}
                    </div>

                    <button 
                        type="submit" 
                        className="auth-button"
                        disabled={loading}
                    >
                        {loading ? 'Signing In...' : 'Sign In'}
                    </button>
                </form>

                <div className="auth-divider">
                    <span>or</span>
                </div> */}

                <button 
                    type="button" 
                    className="sso-button"
                    onClick={loginWithSSO}
                    disabled={loading}
                >
                    Sign in with Bedrockmfg SSO
                </button>

                {/* <div className="auth-links">
                    <button 
                        type="button" 
                        className="link-button"
                        onClick={onSwitchToForgotPassword}
                    >
                        Forgot Password?
                    </button>
                    <span>Don't have an account? </span>
                    <button 
                        type="button" 
                        className="link-button"
                        onClick={onSwitchToSignup}
                    >
                        Sign Up
                    </button>
                </div> */}
            </div>
        </div>
    );
};

export default Login; 